// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Clock as RawClock } from "lucide-react";
export const Clock = /* @__PURE__ */ createIcon(RawClock, "Clock", 2);
